module.exports = __webpack_public_path__ + "img/trash.1a8a64ca.svg";